// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
var __pngack_exports__ = __pngack_require__(638);
